import { createGlobalState, useStorage } from '@vueuse/core'

export const useGlobalCart = createGlobalState(() => {
    const cart = {
        appName: _theme['appName'],
        appLogo: _theme['logo'],
        app_id: _config['app_id'],
        total_value: 0,
        tax_value: 0,
        app_type: 'SMART-MENU',
        table_unique_id: null,
        products: [],
        combos: []
    };

    const storage = JSON.parse(localStorage.getItem('cart'))

    /**
     * Como o appName não existia originalmente, então se o app da storage for diferente do app acessado OU não tiver
     * o appName no storage, então limpa o localstora e começa do zero pra evitar inconsistencia.
     */
    if (storage && (storage.app_id !== _config['app_id']) || !storage?.appName) {
        const json = JSON.stringify(cart);
        localStorage.setItem('cart', json)
        return useStorage('cart', cart, localStorage, { mergeDefaults: true })
    }

    return useStorage('cart', cart)
})

export const useGlobalRequests = createGlobalState(() => {
    const storage = JSON.parse(localStorage.getItem('requests'))
    const request = {
        requests: [],
    };

    /**
     * Provisoriamente se não existir o appName em algum pedido que o usuário já tenha feito,
     * então remover o histórico de request pois novas alterações visuais foram adicionadas e quebraria se não
     * houvesse appName e appLogo nos requests passados
    */
    if (storage && !storage?.requests[0]?.cart.appName) {
        localStorage.setItem('requests', JSON.stringify(request))
        return useStorage('requests', request, localStorage, { mergeDefaults: true })

    }

    return useStorage('requests', request);
})